export default class ClientForm {
    id
    integrationCode
    personDocument
    personName
    fantasyName
    stateRegistration
    municipalRegistration
    activityArea
    clientDescription
    clientDescriptionText
    addressName
    number
    detail
    neighborhood
    zipCode
    city
    state
    personPhone
    personAlternativePhone
    filial
    personEmail
    clientClassification
    printNumber
    personType
}
